import Keycloak, { KeycloakConfig} from 'keycloak-js'
import psl from 'psl'

const keycloakConfig: KeycloakConfig  = {
  url: process.env.REACT_APP_KEYCLOAK_URL,
  realm: 'gupy',
  clientId: 'gupy-front', 
};

const keycloakInitOptions = () => {
  const params = (new URL(window.location.href)).searchParams;
  const redirectUri = params.get('redirect_uri');
  const exchangeTokenError = params.get('exchange_token_error');
  const gupyCompanyId = params.get('gupyCompanyId');

    if (!redirectUri) return {};

    try {
      const hostname = new URL(redirectUri).hostname;
      const { domain } = psl.parse(hostname.replace(/_/g, ''));
        
      if (domain !== 'gupy.io' && domain !== 'niduu.com')
        return {};

      const exchangeTokenErrorParam = exchangeTokenError ? `&exchange_token_error=${exchangeTokenError}` : '';
      const gupyCompanyIdParam = gupyCompanyId ? `&gupyCompanyId=${gupyCompanyId}` : '';

      return {
        onLoad: 'login-required',
        redirectUri:
          `${process.env.REACT_APP_OAUTH_CALLBACK_URL}?redirect_uri=${redirectUri}${exchangeTokenErrorParam}${gupyCompanyIdParam}`,
      };
    } catch (error) {
      console.error(error);
      return {};
    }
  }

const keycloak = new Keycloak(keycloakConfig);

export { keycloak, keycloakInitOptions };
